import { DataResponseTransformed, TabletReactQueryState } from "./tabletReactQuery";

export interface StageState {
  id: number;
  key: string;
  name: string;
}

export interface Stage {
  id: number;
  key: string;
  from_state: StageState;
  to_state: StageState;
  description: string;
}

export interface StagesModel extends DataResponseTransformed {
  rows: Stage[];
}

export interface StagesState extends TabletReactQueryState {}

export const stagesBuilder = {
  fromBackEnd: (stage: any): Stage => ({
    id: stage.id,
    key: stage.key,
    from_state: {
      id: stage.from_state.id,
      key: stage.from_state.key,
      name: stage.from_state.name,
    },
    to_state: {
      id: stage.to_state.id,
      key: stage.to_state.key,
      name: stage.to_state.name,
    },
    description: stage.description,
  }),
};

